import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarContratoTarjeta({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const id = registro.id;
      if (!id) throw new Error("ID no encontrado.");
      const url = apiRoutes.contratoTarjeta.eliminarUrl(id);
      await appFetchJson(url, { method: "DELETE" });
      onDeleted();
      onClose();
    } catch (e) {
      console.error("Error al eliminar la asignación:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Asignación</h2>
      </div>

      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm text-blue-600">
          ¿Está seguro que desea eliminar esta asignación?
        </div>

        <div className="bg-gray-50 px-6 py-6 mb-2 space-y-2">
          <div>
            <span className="text-gray-500 mr-1">Contrato:</span>
            <span className="font-medium">{registro.contratoCodigo ?? "—"}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Tarjeta:</span>
            <span className="font-medium">{registro.tarjetaNumero ?? "—"}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Estado:</span>
            <span className="font-medium">{registro.estadoNombre ?? "—"}</span>
          </div>
        </div>
      </div>

      <div className="px-6 py-4 border-t flex gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>
        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}